var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H13M22 15.798C22 13.166 22 11.849 21.23 10.994C21.1594 10.9151 21.0846 10.84 21.006 10.769C20.151 10 18.834 10 16.202 10H15.828C14.675 10 14.098 10 13.56 9.847C13.2648 9.7626 12.9802 9.64449 12.712 9.495C12.224 9.224 11.816 8.815 11 8L10.45 7.45C10.176 7.176 10.04 7.04 9.896 6.92C9.27667 6.40664 8.51694 6.09194 7.716 6.017C7.53 6 7.336 6 6.95 6C6.067 6 5.626 6 5.258 6.07C4.46784 6.21922 3.741 6.60314 3.17231 7.17165C2.60361 7.74017 2.21947 8.46689 2.07 9.257C2 9.626 2 10.068 2 10.95M21.991 20C21.955 22.48 21.771 23.885 20.828 24.828C19.657 26 17.771 26 14 26H10C6.229 26 4.343 26 3.172 24.828C2.001 23.656 2 21.771 2 18V15",
    stroke: "#050A30",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.0288d919394d9a2bd936e9156bcb5324.svg";
export { ForwardRef as ReactComponent };